import React, { useEffect } from "react";
import type { FC, MouseEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { useGetCurrentUserQuery } from "store/current-user/current-user.api";
import { currentUserActions } from "store/current-user/current-user.slice";
import { ReactComponent as EditSVG } from "assets/images/edit-outline.svg";
import { ReactComponent as StarSVG } from "assets/images/star-outline-white.svg";
import { ReactComponent as ShareSVG } from "assets/images/share.svg";
import { ReactComponent as LogoutSVG } from "assets/images/logout-outline.svg";
import { logout } from "store/current-user/current-user.thunk";

export const ProfileMenu: FC = () => {
  const { profileMenu } = useShallowPickSelector("app", ["profileMenu"]);
  const { user, auth } = useShallowPickSelector("currentUser", [
    "user",
    "auth",
  ]);
  const { data: profile } = useGetCurrentUserQuery(
    { currentUserId: user?.id! },
    { skip: !user || !auth || !profileMenu.isOpen }
  );


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  useEffect(() => {
    if(profile)
      dispatch(currentUserActions.setUser(profile));
  }, [profile]);

  const onClose = () => {
    dispatch(appActions.setProfileMenu({ isOpen: false }));
  };

  const onClickEditUser: MouseEventHandler = () => {
    navigate("/edit-user");
    onClose();
  };

  const onClickUpgrade: MouseEventHandler = () => {
    navigate("/upgrade");
    onClose();
  };

  const onClickShareProfile: MouseEventHandler = () => {
    if (user) {
      const shareData = {
        url: `https://avagap.com/profile/@${user.id}`,
      };
      if (
        !!navigator.share &&
        !!navigator.canShare &&
        navigator.canShare(shareData)
      ) {
        onClose();
        navigator.share(shareData);
      } else if (!!navigator.clipboard && !!navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareData.url).then(() => {
          dispatch(
            appActions.setSnackbar({
              isOpen: true,
              message: "لینک کاربر کپی شد",
              severity: "info",
            })
          );
          onClose();
        });
      }
    }
  };

  const onClickLogout: MouseEventHandler = () => {
    dispatch(appActions.setLogoutConfirmationMenu({ isOpen: true }));
    onClose();
  };

  return (
    <BottomSheet
      title={"گزینه‌ها"}
      isOpen={profileMenu.isOpen}
      onClose={onClose}
      items={[
        { text: "ویرایش حساب", icon: <EditSVG />, onClick: onClickEditUser },
        {
          text: profile?.accountSubscriptionIsEnabled
            ? "تمدید اشتراک"
            : "خرید اشتراک",
          icon: <StarSVG />,
          onClick: onClickUpgrade,
        },
        {
          text: "اشتراک‌گذاری",
          icon: <ShareSVG />,
          onClick: onClickShareProfile,
        },
        { text: "خروج از حساب", icon: <LogoutSVG />, onClick: onClickLogout },
      ]}
    />
  );
};
